import React from "react";
import { Header } from '../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import { Redirect } from 'react-router'

export class CookiePolicy extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            chkboxAll: true,
            chkboxMarketing: false,
            chkboxAnalytics: false
        };
        this.acceptAllCookies = this.acceptAllCookies.bind(this);
        this.handleChangeChkAll = this.handleChangeChkAll.bind(this);
        this.handleChangeChkMarketing = this.handleChangeChkMarketing.bind(this);
        this.handleChangeChkAnalytic = this.handleChangeChkAnalytic.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        setTimeout(() => this.props.showCookiePopUpFn(false), 0);

        let marketing = casino.utils.getCookie('marketing');
        let analytic = casino.utils.getCookie('analytic');

        this.setState({
            chkboxMarketing: marketing == '1' ? true : false,
            chkboxAnalytics: analytic == '1' ? true : false
        });
    }

    componentWillUnmount() {
        setTimeout(() => this.props.showCookiePopUpFn(null), 0);
    }

    acceptAllCookies() {
        casino.utils.setCookie("cookie_consent", 1, 365);
        casino.utils.setCookie("marketing", 1, 365);
        casino.utils.setCookie("analytic", 1, 365);
        //casino.utils.setCookie("visitor", casino.utils.uuidv4(), 365);

        //Load GTM
        casino.utils.loadGTMScript();
        //Load Frosmo
        //casino.utils.loadFrosmoScript();
        //Load CrazyEgg
        /*casino.utils.loadCrazyEggSctipt();*/
        casino.utils.loadMSClaritySctipt();

        //Check Affiliate URL link
        //Commented out, see https://supersport.atlassian.net/browse/SCCM-1848?focusedCommentId=57653
        //var wm_param = casino.utils.getURLParameter('wm');
        //if (wm_param !== undefined && wm_param !== 'undefined' && wm_param !== '') {
        //    casino.utils.setCookie("affiliate", wm_param, 30);
        //}

        this.props.showCookiePopUpFn(false);
        this.setState({ redirect: true });
    }

    handleChangeChkAll() {
        this.setState({ chkboxAll: !this.state.chkboxAll });
    }

    handleChangeChkMarketing() {
        this.setState({ chkboxMarketing: !this.state.chkboxMarketing });
    }

    handleChangeChkAnalytic() {
        this.setState({ chkboxAnalytics: !this.state.chkboxAnalytics });
    }

    save() {
        if (!this.state.chkboxAll) return;

        casino.utils.setCookie("cookie_consent", 1, 365);
        //casino.utils.setCookie("visitor", casino.utils.uuidv4(), 365);

        if (this.state.chkboxMarketing) {
            casino.utils.setCookie("marketing", 1, 365);
            //Load Frosmo
            //casino.utils.loadFrosmoScript();

            //Check Affiliate URL link
            //Commented out, see https://supersport.atlassian.net/browse/SCCM-1848?focusedCommentId=57653
            //var wm_param = casino.utils.getURLParameter('wm');
            //if (wm_param !== undefined && wm_param !== 'undefined' && wm_param !== '') {
            //    casino.utils.setCookie("affiliate", wm_param, 30);
            //}
        }
        else {
            casino.utils.deleteCookie('marketing');
            if (casino.utils.getCookie("affiliate")) {
                casino.utils.deleteCookie("affiliate")
            }
        }
        if (this.state.chkboxAnalytics) {
            casino.utils.setCookie("analytic", 1, 365);
            //Load GTM
            casino.utils.loadGTMScript();
            //Load CrazyEgg
         /*   casino.utils.loadCrazyEggSctipt();*/
            casino.utils.loadMSClaritySctipt();
        }
        else {
            casino.utils.deleteCookie("analytic");
            casino.utils.removeGTMScript();
        }

        this.setState({ redirect: true });
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/" push={true} />
        } else {
            return (<div>
                <MetaTags title="Postavke kolačića - SuperSport CASINO" description="Postavke kolačića - SuperSport CASINO!" />
                <Header key="header" {...this.state} {...this.props}></Header>
                <div className='white-background'>
                    <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile">
                        <div id="cookie-policy">
                            <div className="title">Postavke kolačića</div>
                            <div className="divider">&nbsp;</div>
                            <div className="setting">
                                <div>
                                    <div className="c-title">Nužni kolačići</div>
                                    <div className="c-desc">
                                        Ovi kolačići se koriste iz tehničkih razloga i nužni su
                                        za učinkovit rad web stranice, stoga se ne mogu isključiti.
                                    </div>
                                </div>
                                <div>
                                    <label className="switch">
                                        <input type="checkbox" defaultChecked={true} disabled />
                                        <span className="slider round essential"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="setting">
                                <div>
                                    <div className="c-title">Marketinški kolačići</div>
                                    <div className="c-desc">
                                        Ovi kolačići koriste informacije o pregledavanju kako
                                        bi oglašavanje bilo relevantnije za tebe i tvoje potrebe.
                                    </div>
                                </div>
                                <div>
                                    <label className="switch">
                                        <input type="checkbox" checked={this.state.chkboxMarketing} defaultChecked={false} onChange={this.handleChangeChkMarketing} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="setting">
                                <div>
                                    <div className="c-title">Analitički kolačići</div>
                                    <div className="c-desc">
                                        Ovi kolačići omogućuju nam da pratimo posjećenost i interakciju korisnika
                                        s našom web stranicom, kako bismo mogli poboljšati naše usluge.
                                    </div>
                                </div>
                                <div>
                                    <label className="switch">
                                        <input type="checkbox" checked={this.state.chkboxAnalytics} defaultChecked={false} onChange={this.handleChangeChkAnalytic} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="cookie-actions">
                                <div className="cookie-btn blue" onClick={this.acceptAllCookies}>Prihvati sve</div>
                                <div className={"cookie-btn white" + (!this.state.chkboxAll ? ' disabled' : '')} onClick={this.save}>Spremi</div>
                            </div>
                            <div className="cookie-full"><a href="https://mcasino.supersport.hr/pravila/politika-kolacica">Pogledaj Politiku kolačića</a></div>
                        </div>
                    </div>
                </div>
                <ObavijestiCasino {...this.props}></ObavijestiCasino>
            </div>)
        }
    }
}